export default "__VITE_ASSET__44cfa733__"